// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue: rgb(0, 125, 255);
  --blue-dark: rgb(0, 95, 200);
  --bg: #f5f8fc;
  --card: #ffffff;
  --border: rgba(0, 125, 255, 0.18);
  --text: #0f172a;
  --muted: #475569;
  --shadow: 0 10px 30px rgba(2, 8, 23, 0.08);

  --h: 38px; /* единая высота контролов */
}

/* page */

.DinamRoutes_wrapper__McsJp {
  height: calc(100vh - 145px);
  padding: 20px;
  background: var(--bg);
  overflow-x: auto;
}

.DinamRoutes_topBar__jiwZD {
  margin-bottom: 12px;
  display: flex;
  gap: 10px;
}

/* board */

.DinamRoutes_board__hQLHA {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

/* buttons */

.DinamRoutes_primaryBtn__t\\+bOG,
.DinamRoutes_secondaryBtn__Unu4k,
.DinamRoutes_dangerBtn__fGQrf {
  height: var(--h);
  padding: 0 12px;
  border-radius: 10px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid transparent;
}

.DinamRoutes_primaryBtn__t\\+bOG {
  background: var(--blue);
  color: white;
  border-color: var(--blue);
}

.DinamRoutes_primaryBtn__t\\+bOG:hover {
  background: var(--blue-dark);
  border-color: var(--blue-dark);
}

.DinamRoutes_secondaryBtn__Unu4k {
  background: white;
  color: var(--blue);
  border-color: rgba(0, 125, 255, 0.35);
}

.DinamRoutes_secondaryBtn__Unu4k:hover {
  border-color: var(--blue);
}

.DinamRoutes_dangerBtn__fGQrf {
  background: white;
  color: #b91c1c;
  border-color: rgba(185, 28, 28, 0.35);
}

.DinamRoutes_dangerBtn__fGQrf:hover {
  border-color: rgba(185, 28, 28, 0.7);
}

/* route card */

.DinamRoutes_routeCard__IrH2P {
  width: 320px;
  background: var(--card);
  border-radius: 16px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.DinamRoutes_routeHeader__srmi7 {
  padding: 12px;
  border-bottom: 1px solid rgba(0, 125, 255, 0.12);
  background: linear-gradient(180deg, rgba(0, 125, 255, 0.06), rgba(0, 125, 255, 0));
}

.DinamRoutes_routeHeaderTop__ZpKF4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.DinamRoutes_routeTitle__TfOxQ {
  font-weight: 700;
  color: var(--text);
}

.DinamRoutes_routeOpened__YxTcw {
  height: var(--h);
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 10px;
  background: rgba(0, 125, 255, 0.10);
  color: var(--blue-dark);
  font-size: 13px;
  border: 1px solid rgba(0, 125, 255, 0.22);
}

.DinamRoutes_routeMetaGrid__FjfvS {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.DinamRoutes_routeMetaRow__wAJ6P {
  display: grid;
  grid-template-columns: 120px 1fr;
  align-items: center;
  gap: 10px;
}

.DinamRoutes_metaLabel__4xKLj {
  font-size: 12px;
  color: var(--muted);
}

.DinamRoutes_metaValue__7p\\+fD {
  font-size: 13px;
  color: var(--text);
}

.DinamRoutes_maxQtyInput__8B080 {
  height: 30px;
  width: 90px;
  border-radius: 10px;
  border: 1px solid rgba(0, 125, 255, 0.25);
  padding: 0 10px;
  outline: none;
}

.DinamRoutes_maxQtyInput__8B080:focus {
  border-color: rgba(0, 125, 255, 0.7);
  box-shadow: 0 0 0 4px rgba(0, 125, 255, 0.12);
}

.DinamRoutes_overload__WaLdz {
  color: #b91c1c;
  font-weight: 600;
}

/* receipts */

.DinamRoutes_receipts__p81zg {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.DinamRoutes_receipt__1-4eK {
  border-radius: 14px;
  padding: 10px;
  border: 1px solid rgba(0, 125, 255, 0.14);
}

.DinamRoutes_receiptTop__inb6V {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.DinamRoutes_receiptTitle__3x\\+2n {
  font-weight: 700;
  color: var(--text);
}

.DinamRoutes_receiptLine__UXlhU {
  font-size: 12.5px;
  color: var(--muted);
  line-height: 1.35;
}

.DinamRoutes_controlsRow__1nfpq {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.DinamRoutes_control__kqjak {
  height: var(--h);
  border-radius: 10px;
  font-size: 13px;
  border: 1px solid rgba(0, 125, 255, 0.25);
  background: white;
  padding: 0 10px;
  outline: none;
}

.DinamRoutes_control__kqjak:focus {
  border-color: rgba(0, 125, 255, 0.7);
  box-shadow: 0 0 0 4px rgba(0, 125, 255, 0.12);
}

.DinamRoutes_actionBtn__-1Hmo {
  color: var(--blue);
  cursor: pointer;
}

/* add route */

.DinamRoutes_addRoute__Q60Vd {
  width: 320px;
  height: 140px;
  border-radius: 16px;
  border: 2px dashed rgba(0, 125, 255, 0.55);
  background: rgba(0, 125, 255, 0.04);
  color: var(--blue);
  font-size: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: var(--shadow);
}

.DinamRoutes_addRoute__Q60Vd:hover {
  background: rgba(0, 125, 255, 0.07);
  border-color: rgba(0, 125, 255, 0.8);
}

/* trash */

.DinamRoutes_trash__vb38t {
  width: 280px;
  background: var(--card);
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  box-shadow: var(--shadow);
  padding: 12px;
}

.DinamRoutes_trashTitle__Y2jke {
  font-weight: 700;
  color: var(--text);
  margin-bottom: 8px;
}

.DinamRoutes_trashEmpty__u5AaA {
  font-size: 12.5px;
  color: var(--muted);
}

.DinamRoutes_trashList__lndKf {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.DinamRoutes_trashItem__h8Ld1 {
  background: #fff1f2;
  border: 1px solid rgba(190, 18, 60, 0.18);
  border-radius: 12px;
  padding: 8px;
}

.DinamRoutes_trashItemTitle__2u1Pv {
  font-weight: 700;
  color: #7f1d1d;
  font-size: 12.5px;
}

.DinamRoutes_trashItemMeta__mBX88 {
  font-size: 12px;
  color: #7f1d1d;
  opacity: 0.85;
  margin-top: 2px;
}

/* modal */

.DinamRoutes_modalOverlay__cVbg7 {
  position: fixed;
  inset: 0;
  background: rgba(2, 8, 23, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.DinamRoutes_modal__gNjRp {
  width: 360px;
  background: white;
  border-radius: 16px;
  border: 1px solid rgba(0, 125, 255, 0.18);
  box-shadow: 0 20px 70px rgba(2, 8, 23, 0.22);
  padding: 14px;
}

.DinamRoutes_modalTitle__RT85i {
  font-weight: 800;
  color: var(--text);
  margin-bottom: 6px;
}

.DinamRoutes_modalText__5oBiN {
  font-size: 12.5px;
  color: var(--muted);
  line-height: 1.4;
}

.DinamRoutes_modalActions__R7CQU {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* tones */

.DinamRoutes_badge__8MrZE {
  height: 26px;
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid transparent;
  white-space: nowrap;
}

/* badge colors */
.DinamRoutes_badge_gray__\\+O4tE { background: rgba(148, 163, 184, 0.18); color: #334155; border-color: rgba(148, 163, 184, 0.35); }
.DinamRoutes_badge_blue__h4HhK { background: rgba(0, 125, 255, 0.14); color: rgb(0, 95, 200); border-color: rgba(0, 125, 255, 0.35); }
.DinamRoutes_badge_green__wvfHB { background: rgba(16, 185, 129, 0.16); color: #065f46; border-color: rgba(16, 185, 129, 0.35); }
.DinamRoutes_badge_orange__vnDtt { background: rgba(245, 158, 11, 0.18); color: #92400e; border-color: rgba(245, 158, 11, 0.35); }
.DinamRoutes_badge_purple__sPVTO { background: rgba(139, 92, 246, 0.16); color: #5b21b6; border-color: rgba(139, 92, 246, 0.35); }
.DinamRoutes_badge_red__EjbDj { background: rgba(239, 68, 68, 0.16); color: #7f1d1d; border-color: rgba(239, 68, 68, 0.35); }
.DinamRoutes_badge_teal__snX6p { background: rgba(20, 184, 166, 0.16); color: #115e59; border-color: rgba(20, 184, 166, 0.35); }
.DinamRoutes_badge_dark__gts0U { background: rgba(15, 23, 42, 0.12); color: #0f172a; border-color: rgba(15, 23, 42, 0.22); }

/* receipt background by tone */
.DinamRoutes_receipt_gray__Wve7b { background: rgba(148, 163, 184, 0.12); }
.DinamRoutes_receipt_blue__1uZS2 { background: rgba(0, 125, 255, 0.08); }
.DinamRoutes_receipt_green__X9aLn { background: rgba(16, 185, 129, 0.10); }
.DinamRoutes_receipt_orange__uiXXh { background: rgba(245, 158, 11, 0.12); }
.DinamRoutes_receipt_purple__tetk8 { background: rgba(139, 92, 246, 0.10); }
.DinamRoutes_receipt_red__YR0nA { background: rgba(239, 68, 68, 0.10); }
.DinamRoutes_receipt_teal__qYuw8 { background: rgba(20, 184, 166, 0.10); }
.DinamRoutes_receipt_dark__qCZZ5 { background: rgba(15, 23, 42, 0.08); }
`, "",{"version":3,"sources":["webpack://./src/modules/Developer/ExamplePages/DinamRoutes/DinamRoutes.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,0CAA0C;;EAE1C,SAAS,EAAE,4BAA4B;AACzC;;AAEA,SAAS;;AAET;EACE,2BAA2B;EAC3B,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,YAAY;;AAEZ;;;EAGE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,eAAe;;AAEf;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,cAAc;;AAEd;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,UAAU;;AAEV;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,UAAU;;AAEV;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB,kCAAc,qCAAqC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AAC9G,iCAAc,mCAAmC,EAAE,sBAAsB,EAAE,qCAAqC,EAAE;AAClH,kCAAe,oCAAoC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AAC7G,mCAAgB,oCAAoC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AAC9G,mCAAgB,oCAAoC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AAC9G,gCAAa,mCAAmC,EAAE,cAAc,EAAE,qCAAqC,EAAE;AACzG,iCAAc,oCAAoC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AAC5G,iCAAc,kCAAkC,EAAE,cAAc,EAAE,oCAAoC,EAAE;;AAExG,+BAA+B;AAC/B,mCAAgB,qCAAqC,EAAE;AACvD,mCAAgB,mCAAmC,EAAE;AACrD,oCAAiB,oCAAoC,EAAE;AACvD,qCAAkB,oCAAoC,EAAE;AACxD,qCAAkB,oCAAoC,EAAE;AACxD,kCAAe,mCAAmC,EAAE;AACpD,mCAAgB,oCAAoC,EAAE;AACtD,mCAAgB,kCAAkC,EAAE","sourcesContent":[":root {\r\n  --blue: rgb(0, 125, 255);\r\n  --blue-dark: rgb(0, 95, 200);\r\n  --bg: #f5f8fc;\r\n  --card: #ffffff;\r\n  --border: rgba(0, 125, 255, 0.18);\r\n  --text: #0f172a;\r\n  --muted: #475569;\r\n  --shadow: 0 10px 30px rgba(2, 8, 23, 0.08);\r\n\r\n  --h: 38px; /* единая высота контролов */\r\n}\r\n\r\n/* page */\r\n\r\n.wrapper {\r\n  height: calc(100vh - 145px);\r\n  padding: 20px;\r\n  background: var(--bg);\r\n  overflow-x: auto;\r\n}\r\n\r\n.topBar {\r\n  margin-bottom: 12px;\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n/* board */\r\n\r\n.board {\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: flex-start;\r\n}\r\n\r\n/* buttons */\r\n\r\n.primaryBtn,\r\n.secondaryBtn,\r\n.dangerBtn {\r\n  height: var(--h);\r\n  padding: 0 12px;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.primaryBtn {\r\n  background: var(--blue);\r\n  color: white;\r\n  border-color: var(--blue);\r\n}\r\n\r\n.primaryBtn:hover {\r\n  background: var(--blue-dark);\r\n  border-color: var(--blue-dark);\r\n}\r\n\r\n.secondaryBtn {\r\n  background: white;\r\n  color: var(--blue);\r\n  border-color: rgba(0, 125, 255, 0.35);\r\n}\r\n\r\n.secondaryBtn:hover {\r\n  border-color: var(--blue);\r\n}\r\n\r\n.dangerBtn {\r\n  background: white;\r\n  color: #b91c1c;\r\n  border-color: rgba(185, 28, 28, 0.35);\r\n}\r\n\r\n.dangerBtn:hover {\r\n  border-color: rgba(185, 28, 28, 0.7);\r\n}\r\n\r\n/* route card */\r\n\r\n.routeCard {\r\n  width: 320px;\r\n  background: var(--card);\r\n  border-radius: 16px;\r\n  border: 1px solid var(--border);\r\n  box-shadow: var(--shadow);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.routeHeader {\r\n  padding: 12px;\r\n  border-bottom: 1px solid rgba(0, 125, 255, 0.12);\r\n  background: linear-gradient(180deg, rgba(0, 125, 255, 0.06), rgba(0, 125, 255, 0));\r\n}\r\n\r\n.routeHeaderTop {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.routeTitle {\r\n  font-weight: 700;\r\n  color: var(--text);\r\n}\r\n\r\n.routeOpened {\r\n  height: var(--h);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0 12px;\r\n  border-radius: 10px;\r\n  background: rgba(0, 125, 255, 0.10);\r\n  color: var(--blue-dark);\r\n  font-size: 13px;\r\n  border: 1px solid rgba(0, 125, 255, 0.22);\r\n}\r\n\r\n.routeMetaGrid {\r\n  margin-top: 10px;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 8px;\r\n}\r\n\r\n.routeMetaRow {\r\n  display: grid;\r\n  grid-template-columns: 120px 1fr;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.metaLabel {\r\n  font-size: 12px;\r\n  color: var(--muted);\r\n}\r\n\r\n.metaValue {\r\n  font-size: 13px;\r\n  color: var(--text);\r\n}\r\n\r\n.maxQtyInput {\r\n  height: 30px;\r\n  width: 90px;\r\n  border-radius: 10px;\r\n  border: 1px solid rgba(0, 125, 255, 0.25);\r\n  padding: 0 10px;\r\n  outline: none;\r\n}\r\n\r\n.maxQtyInput:focus {\r\n  border-color: rgba(0, 125, 255, 0.7);\r\n  box-shadow: 0 0 0 4px rgba(0, 125, 255, 0.12);\r\n}\r\n\r\n.overload {\r\n  color: #b91c1c;\r\n  font-weight: 600;\r\n}\r\n\r\n/* receipts */\r\n\r\n.receipts {\r\n  padding: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.receipt {\r\n  border-radius: 14px;\r\n  padding: 10px;\r\n  border: 1px solid rgba(0, 125, 255, 0.14);\r\n}\r\n\r\n.receiptTop {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.receiptTitle {\r\n  font-weight: 700;\r\n  color: var(--text);\r\n}\r\n\r\n.receiptLine {\r\n  font-size: 12.5px;\r\n  color: var(--muted);\r\n  line-height: 1.35;\r\n}\r\n\r\n.controlsRow {\r\n  margin-top: 10px;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 10px;\r\n}\r\n\r\n.control {\r\n  height: var(--h);\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  border: 1px solid rgba(0, 125, 255, 0.25);\r\n  background: white;\r\n  padding: 0 10px;\r\n  outline: none;\r\n}\r\n\r\n.control:focus {\r\n  border-color: rgba(0, 125, 255, 0.7);\r\n  box-shadow: 0 0 0 4px rgba(0, 125, 255, 0.12);\r\n}\r\n\r\n.actionBtn {\r\n  color: var(--blue);\r\n  cursor: pointer;\r\n}\r\n\r\n/* add route */\r\n\r\n.addRoute {\r\n  width: 320px;\r\n  height: 140px;\r\n  border-radius: 16px;\r\n  border: 2px dashed rgba(0, 125, 255, 0.55);\r\n  background: rgba(0, 125, 255, 0.04);\r\n  color: var(--blue);\r\n  font-size: 40px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  box-shadow: var(--shadow);\r\n}\r\n\r\n.addRoute:hover {\r\n  background: rgba(0, 125, 255, 0.07);\r\n  border-color: rgba(0, 125, 255, 0.8);\r\n}\r\n\r\n/* trash */\r\n\r\n.trash {\r\n  width: 280px;\r\n  background: var(--card);\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(15, 23, 42, 0.12);\r\n  box-shadow: var(--shadow);\r\n  padding: 12px;\r\n}\r\n\r\n.trashTitle {\r\n  font-weight: 700;\r\n  color: var(--text);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.trashEmpty {\r\n  font-size: 12.5px;\r\n  color: var(--muted);\r\n}\r\n\r\n.trashList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.trashItem {\r\n  background: #fff1f2;\r\n  border: 1px solid rgba(190, 18, 60, 0.18);\r\n  border-radius: 12px;\r\n  padding: 8px;\r\n}\r\n\r\n.trashItemTitle {\r\n  font-weight: 700;\r\n  color: #7f1d1d;\r\n  font-size: 12.5px;\r\n}\r\n\r\n.trashItemMeta {\r\n  font-size: 12px;\r\n  color: #7f1d1d;\r\n  opacity: 0.85;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* modal */\r\n\r\n.modalOverlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(2, 8, 23, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n}\r\n\r\n.modal {\r\n  width: 360px;\r\n  background: white;\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(0, 125, 255, 0.18);\r\n  box-shadow: 0 20px 70px rgba(2, 8, 23, 0.22);\r\n  padding: 14px;\r\n}\r\n\r\n.modalTitle {\r\n  font-weight: 800;\r\n  color: var(--text);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.modalText {\r\n  font-size: 12.5px;\r\n  color: var(--muted);\r\n  line-height: 1.4;\r\n}\r\n\r\n.modalActions {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n/* tones */\r\n\r\n.badge {\r\n  height: 26px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0 10px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  border: 1px solid transparent;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* badge colors */\r\n.badge_gray { background: rgba(148, 163, 184, 0.18); color: #334155; border-color: rgba(148, 163, 184, 0.35); }\r\n.badge_blue { background: rgba(0, 125, 255, 0.14); color: rgb(0, 95, 200); border-color: rgba(0, 125, 255, 0.35); }\r\n.badge_green { background: rgba(16, 185, 129, 0.16); color: #065f46; border-color: rgba(16, 185, 129, 0.35); }\r\n.badge_orange { background: rgba(245, 158, 11, 0.18); color: #92400e; border-color: rgba(245, 158, 11, 0.35); }\r\n.badge_purple { background: rgba(139, 92, 246, 0.16); color: #5b21b6; border-color: rgba(139, 92, 246, 0.35); }\r\n.badge_red { background: rgba(239, 68, 68, 0.16); color: #7f1d1d; border-color: rgba(239, 68, 68, 0.35); }\r\n.badge_teal { background: rgba(20, 184, 166, 0.16); color: #115e59; border-color: rgba(20, 184, 166, 0.35); }\r\n.badge_dark { background: rgba(15, 23, 42, 0.12); color: #0f172a; border-color: rgba(15, 23, 42, 0.22); }\r\n\r\n/* receipt background by tone */\r\n.receipt_gray { background: rgba(148, 163, 184, 0.12); }\r\n.receipt_blue { background: rgba(0, 125, 255, 0.08); }\r\n.receipt_green { background: rgba(16, 185, 129, 0.10); }\r\n.receipt_orange { background: rgba(245, 158, 11, 0.12); }\r\n.receipt_purple { background: rgba(139, 92, 246, 0.10); }\r\n.receipt_red { background: rgba(239, 68, 68, 0.10); }\r\n.receipt_teal { background: rgba(20, 184, 166, 0.10); }\r\n.receipt_dark { background: rgba(15, 23, 42, 0.08); }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `DinamRoutes_wrapper__McsJp`,
	"topBar": `DinamRoutes_topBar__jiwZD`,
	"board": `DinamRoutes_board__hQLHA`,
	"primaryBtn": `DinamRoutes_primaryBtn__t+bOG`,
	"secondaryBtn": `DinamRoutes_secondaryBtn__Unu4k`,
	"dangerBtn": `DinamRoutes_dangerBtn__fGQrf`,
	"routeCard": `DinamRoutes_routeCard__IrH2P`,
	"routeHeader": `DinamRoutes_routeHeader__srmi7`,
	"routeHeaderTop": `DinamRoutes_routeHeaderTop__ZpKF4`,
	"routeTitle": `DinamRoutes_routeTitle__TfOxQ`,
	"routeOpened": `DinamRoutes_routeOpened__YxTcw`,
	"routeMetaGrid": `DinamRoutes_routeMetaGrid__FjfvS`,
	"routeMetaRow": `DinamRoutes_routeMetaRow__wAJ6P`,
	"metaLabel": `DinamRoutes_metaLabel__4xKLj`,
	"metaValue": `DinamRoutes_metaValue__7p+fD`,
	"maxQtyInput": `DinamRoutes_maxQtyInput__8B080`,
	"overload": `DinamRoutes_overload__WaLdz`,
	"receipts": `DinamRoutes_receipts__p81zg`,
	"receipt": `DinamRoutes_receipt__1-4eK`,
	"receiptTop": `DinamRoutes_receiptTop__inb6V`,
	"receiptTitle": `DinamRoutes_receiptTitle__3x+2n`,
	"receiptLine": `DinamRoutes_receiptLine__UXlhU`,
	"controlsRow": `DinamRoutes_controlsRow__1nfpq`,
	"control": `DinamRoutes_control__kqjak`,
	"actionBtn": `DinamRoutes_actionBtn__-1Hmo`,
	"addRoute": `DinamRoutes_addRoute__Q60Vd`,
	"trash": `DinamRoutes_trash__vb38t`,
	"trashTitle": `DinamRoutes_trashTitle__Y2jke`,
	"trashEmpty": `DinamRoutes_trashEmpty__u5AaA`,
	"trashList": `DinamRoutes_trashList__lndKf`,
	"trashItem": `DinamRoutes_trashItem__h8Ld1`,
	"trashItemTitle": `DinamRoutes_trashItemTitle__2u1Pv`,
	"trashItemMeta": `DinamRoutes_trashItemMeta__mBX88`,
	"modalOverlay": `DinamRoutes_modalOverlay__cVbg7`,
	"modal": `DinamRoutes_modal__gNjRp`,
	"modalTitle": `DinamRoutes_modalTitle__RT85i`,
	"modalText": `DinamRoutes_modalText__5oBiN`,
	"modalActions": `DinamRoutes_modalActions__R7CQU`,
	"badge": `DinamRoutes_badge__8MrZE`,
	"badge_gray": `DinamRoutes_badge_gray__+O4tE`,
	"badge_blue": `DinamRoutes_badge_blue__h4HhK`,
	"badge_green": `DinamRoutes_badge_green__wvfHB`,
	"badge_orange": `DinamRoutes_badge_orange__vnDtt`,
	"badge_purple": `DinamRoutes_badge_purple__sPVTO`,
	"badge_red": `DinamRoutes_badge_red__EjbDj`,
	"badge_teal": `DinamRoutes_badge_teal__snX6p`,
	"badge_dark": `DinamRoutes_badge_dark__gts0U`,
	"receipt_gray": `DinamRoutes_receipt_gray__Wve7b`,
	"receipt_blue": `DinamRoutes_receipt_blue__1uZS2`,
	"receipt_green": `DinamRoutes_receipt_green__X9aLn`,
	"receipt_orange": `DinamRoutes_receipt_orange__uiXXh`,
	"receipt_purple": `DinamRoutes_receipt_purple__tetk8`,
	"receipt_red": `DinamRoutes_receipt_red__YR0nA`,
	"receipt_teal": `DinamRoutes_receipt_teal__qYuw8`,
	"receipt_dark": `DinamRoutes_receipt_dark__qCZZ5`
};
export default ___CSS_LOADER_EXPORT___;
